import { EditorState } from 'prosemirror-state'
import { DecorationSet, Decoration } from 'prosemirror-view'
import cx from 'classnames'
import { getTodosPluginState } from './constants'
import { State } from './Types'
import Styles from './Todos.module.scss'

export const createDecorations = (state: EditorState) => {
  const decorations: Decoration[] = []

  const { docStore, enabled }: State = getTodosPluginState(state)

  // This is just to make it easier to work with typescript. DocStore will
  // always be there at this point.
  if (!docStore || !enabled) {
    return DecorationSet.create(state.doc, decorations)
  }

  const visibleUuids = docStore.todos.map((todo) => todo.uuid)

  state.doc.descendants((node, pos) => {
    const todoMarks = node.marks.filter((mark) => mark.type === state.doc.type.schema.marks.task)
    if (!todoMarks.some((mark) => visibleUuids.includes(mark.attrs.uuid))) {
      return
    }
    // Gradient auxiliary decoration
    // If the node also has a gradient mark, we create an extra
    // decoration beforehand. This creates a span around the text
    // content but inside the gradient color mark.
    const gradientMark = node.marks.find(
      (mark) => mark.type === state.doc.type.schema.marks.colored && mark.attrs.color.startsWith('linear-gradient'),
    )
    if (gradientMark != null) {
      decorations.push(
        Decoration.inline(pos, pos + node.nodeSize, {
          style: `
          background: ${gradientMark.attrs.color};
          background-clip: 'text';
          -webkit-background-clip: text;
          -moz-background-clip: text;
          -webkit-text-fill-color: transparent;
          -moz-text-fill-color: transparent;
        `,
          nodeName: 'span',
        }),
      )
    }

    // Default decoration
    const decoration =
      node.type === state.schema.nodes.smartLink
        ? Decoration.node(pos, pos + node.nodeSize, {
            class: cx(Styles.show, {
              [Styles.highlighted]: todoMarks.some((mark) => {
                return [docStore.rootStore.todos.selected?.uuid, docStore.rootStore.todos.highlighted?.uuid].includes(
                  mark.attrs.uuid,
                )
              }),
            }),
            nodeName: 'span',
            'data-visible': 'true',
          })
        : Decoration.inline(pos, pos + node.nodeSize, {
            class: cx(Styles.show, {
              [Styles.highlighted]: todoMarks.some((mark) => {
                return [docStore.rootStore.todos.selected?.uuid, docStore.rootStore.todos.highlighted?.uuid].includes(
                  mark.attrs.uuid,
                )
              }),
            }),
            nodeName: 'span',
            'data-visible': 'true',
          })

    decorations.push(decoration)
  })

  return DecorationSet.create(state.doc, decorations)
}
